import React from "react";
import { Form, Input, Button, message } from "antd";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { changePassword } from "../../../service/client";

export const ChangePassword: React.FC = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const changePasswordMutation = useMutation(
    async (values: { currentPassword: string; newPassword: string }) => {
      return changePassword(values);
    },
    {
      onSuccess: () => {
        message.success(t("changePassword.passwordChanged"));
        form.resetFields();
      },
      onError: (error: any) => {
        message.error(error?.response?.data?.error || t("changePassword.changeError"));
      },
    }
  );

  const handleSubmit = async (values: any) => {
    await changePasswordMutation.mutateAsync({
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Form.Item
        label={t("changePassword.currentPasswordLabel")}
        name="currentPassword"
        rules={[{ required: true, message: t("changePassword.currentPasswordRequired") }]}
      >
        <Input.Password placeholder={t("changePassword.currentPasswordPlaceholder")} />
      </Form.Item>

      <Form.Item
        label={t("changePassword.newPasswordLabel")}
        name="newPassword"
        rules={[
          { required: true, message: t("changePassword.newPasswordRequired") },
          { min: 6, message: t("changePassword.newPasswordMin") },
        ]}
      >
        <Input.Password placeholder={t("changePassword.newPasswordPlaceholder")} />
      </Form.Item>

      <Form.Item
        label={t("changePassword.confirmPasswordLabel")}
        name="confirmPassword"
        dependencies={["newPassword"]}
        rules={[
          { required: true, message: t("changePassword.confirmPasswordRequired") },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("newPassword") === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t("changePassword.passwordsMismatch")));
            },
          }),
        ]}
      >
        <Input.Password placeholder={t("changePassword.confirmPasswordPlaceholder")} />
      </Form.Item>

      <Form.Item style={{ marginTop: 32 }}>
        <Button
          type="primary"
          htmlType="submit"
          loading={changePasswordMutation.isLoading}
        >
          {t("changePassword.submitButton")}
        </Button>
      </Form.Item>
    </Form>
  );
};
